export const REPORTS_PATH_NAME = 'reports';
